/**
 * Разбор и сравнение значений (аналог normalizeArticle_, isBlankValue_ и др. из Validation.gs).
 * Значения ячеек ввода приходят строками (набраны или вставлены из Excel) и разбираются здесь.
 */
/** OEM: без неразрывных пробелов и крайних пробелов, в верхнем регистре. */
export function normalizeArticle(value) {
    if (value === null || value === undefined)
        return '';
    return String(value).replace(/\u00A0/g, ' ').trim().toUpperCase();
}
export function isBlank(value) {
    return value === '' || value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
}
export function isNum(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
export function isInt(value) {
    return isNum(value) && Math.floor(value) === value;
}
/**
 * Число из текста ячейки. Понимает пробелы и неразрывные пробелы между разрядами, запятую или точку
 * как десятичный разделитель («1 234,50», «1234.5»). «1,234.50» (англ. разряды) тоже понимает.
 */
export function parseNumber(raw) {
    if (isNum(raw))
        return { kind: 'number', value: raw };
    if (isBlank(raw))
        return { kind: 'blank' };
    let s = String(raw).replace(/[\s\u00A0\u202F]/g, '');
    if (/^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(s))
        s = s.replace(/,/g, '');
    else
        s = s.replace(',', '.');
    if (!/^-?(\d+(\.\d*)?|\.\d+)$/.test(s))
        return { kind: 'invalid', raw: String(raw) };
    const value = Number(s);
    return Number.isFinite(value) ? { kind: 'number', value } : { kind: 'invalid', raw: String(raw) };
}
/** Число или null (пусто / не число). */
export function numOrNull(raw) {
    const p = parseNumber(raw);
    return p.kind === 'number' ? p.value : null;
}
export function text(value) {
    return value === null || value === undefined ? '' : String(value).trim();
}
export function sameText(a, b) {
    return text(a).toUpperCase() === text(b).toUpperCase();
}
export function samePrice(a, b) {
    if (a === null || b === null)
        return a === null && b === null;
    return Math.abs(a - b) < 0.005;
}
export function round2(value) {
    return Math.round(value * 100) / 100;
}
export function round3(value) {
    return Math.round(value * 1000) / 1000;
}
//# sourceMappingURL=values.js.map